import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Loading from "../components/Loading";
import { UserRole } from "../api/interface/user.interface";

interface RoleGuardProps {
  roles: UserRole[];
}

export const RoleGuard = ({ roles }: RoleGuardProps) => {
  const location = useLocation();
  const { user, isLoading } = useAuth();

  if (isLoading) return <Loading />;

  if (!user) {
    // Inclure le chemin, la query string ET le hash
    const fullUrl = location.pathname + location.search + location.hash;
    const redirect = encodeURIComponent(fullUrl);
    return <Navigate to={`/auth/login?redirect=${redirect}`} replace />;
  }

  const userRoles = user.roles?.map(r => r.name) || [];

  const hasAccess = roles.some(role =>
    userRoles.includes(role)
  );

  if (!hasAccess) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <Outlet />;
};